import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TimeoutError } from 'rxjs';
import { AppConfigService } from 'src/services/appconfig.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private apiUrl: string = this.appConfig.getConfig('apiUrl');

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private appConfig: AppConfigService
  ) { }



  submitFeedback(apiUrl: string, feedbackData: any): Observable<any> {
    return this.http.post<any>(apiUrl, feedbackData).pipe(
      timeout(12000),
      map((response) => response),
      catchError((err) => {
        console.error('Error in submitFeedback:', err);
        return this.errorHandler(err) || of([]);
      })
    );
  }

  submitGeneralFeedback(feedbackData: any): Observable<any> {
    const apiUrl = this.appConfig.getConfig('apiUrl') + '/submit-feedback';
    return this.http.post<any>(apiUrl, feedbackData).pipe(
      timeout(12000),
      map((response) => response),
      catchError((err) => {
        console.error('Error in submitGeneralFeedback:', err);
        return this.errorHandler(err) || of([]);
      })
    );
  }

  private errorHandler(error: HttpErrorResponse | TimeoutError) {
    if (error instanceof TimeoutError) {
      this.snackBar.open(
        'This is taking longer than usual. Please refresh your browser',
        'Close',
        { duration: 3000 }
      );
    } else {
      this.snackBar.open('An error occurred. Please try again.', 'Close', {
        duration: 3000,
      });
    }
    return throwError(() => new Error(error.message));
  }
}
